(function ($) {
  "use strict";

  const inputLat = $("#radar_lat");
  const inputLng = $("#radar_lng");
  const form = $("#form-radar");

  let lat;
  let lng;

  // Evento de click ao clicar no Radar Coworking
  $(".radar-coworking").on("click", function (e) {
    e.preventDefault();
    getUserLocation();
  });

  // Verifica se a GEOLOCATION API é suportada pelo navegador
  function suportApiGeo() {
    return navigator.geolocation;
  }

  // (GEOLOCATION API) Quando a localização é retornada com sucesso
  function successLocation(position) {
    setLatLng(position.coords.latitude, position.coords.longitude);
    sendForm();
  }

  // (GEOLOCATION API) Quando há um erro na obtenção da localização
  function errorLocation(message) {
    console.log(message);
    getUserLocationByIp();
  }

  // Obtém a localização do usuário
  function getUserLocation() {
    // Verifica o suporte
    if (suportApiGeo()) {
      navigator.geolocation.getCurrentPosition(successLocation, errorLocation);
    } else {
      console.log("Geolocation API não é suportada por este navegador.");
      getUserLocationByIp();
    }
  }

  // Obtém a localização do pelo IP
  function getUserLocationByIp() {
    console.log("Obtendo localização por Ip.");
    $.getJSON(`${url_base}acoes/api/ip_location.php`, function (resp) {
      if (resp) {
        setLatLng(resp.latitude, resp.longitude);
        sendForm();
      }
    });
  }

  // Seta a latitude e longitude
  function setLatLng(latitude, longitude) {
    if (latitude && longitude) {
      // Diminui as casas decimais para 6
      lat = latitude.toFixed(6);
      lng = longitude.toFixed(6);
      inputLat.val(lat);
      inputLng.val(lng);
    }
  }

  // Envia o formulário
  function sendForm() {
    if (lat && lng) {
      form.submit();
    }
  }
})(jQuery);
